export { sendApplePayConfig, useMerchantData } from './useMerchantData';
